import { SelectFieldType } from "../types/Types";

interface Props {
    achievedFilter?: SelectFieldType | null;
    isEstablishmentManager: boolean;
    establishmentId: number | undefined;
    employeeId: number | undefined;
}

export const getAchievedFilter = (props: Props): Record<string, number> => {
    const {
        achievedFilter,
        isEstablishmentManager,
        establishmentId,
        employeeId,
    } = props;

    if (!achievedFilter) return {};

    const isAchieved = achievedFilter?.value === "1";
    const targetId = isEstablishmentManager ? establishmentId : employeeId;

    if (!targetId) return {};

    if (isEstablishmentManager) {
        return isAchieved
            ? { establishment_achieved: establishmentId! }
            : { establishment_not_achieved: establishmentId! };
    }

    return isAchieved
        ? { employee_achieved: employeeId! }
        : { employee_not_achieved: employeeId! };
};
